import { render } from "./BookingView.vue?vue&type=template&id=04837f92&scoped=true"
import script from "./BookingView.vue?vue&type=script&lang=js"
export * from "./BookingView.vue?vue&type=script&lang=js"

import "./BookingView.vue?vue&type=style&index=0&id=04837f92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04837f92"]])

export default __exports__